const commitHash = process.env.NEXT_PUBLIC_COMMIT_HASH;
const version = process.env.NEXT_PUBLIC_NEXT_VERSION ?? "unknown";

export const FRONTEND_VERSION = `${version}:${commitHash}`;
